import { COP_COMMON_ERROR_MESSAGES } from '../../../constants/common-error-messages'
import { ASSETS_SEARCH_ENDPOINT, COP_API_BASE_URL } from '../../../constants/service-endpoints'
import { get } from '../../../services/http.service'
import { ToastService } from '../../../services/toast.service'

const API_BASE_URL = `${COP_API_BASE_URL}${ASSETS_SEARCH_ENDPOINT}`

export interface AssetListParams {
  orderby?: string
  searchText?: string
}

export interface Asset {
  id: string
  serialNumber: string
  productCategoryName: string
  productCategoryId?: string | number
  productName?: string
  status?: string
  installationSite?: string
  customerId?: string
}

export interface AssetListResponse {
  '@odata.count'?: number
  value: Asset[]
}

type AssetListEnvelope =
  | AssetListResponse
  | { data?: AssetListResponse }

function normalizeAssetResponse(raw: AssetListEnvelope): AssetListResponse {
  if (raw && Array.isArray((raw as AssetListResponse).value)) {
    return raw as AssetListResponse
  }
  const nested = (raw as { data?: AssetListResponse }).data
  if (nested && Array.isArray(nested.value)) {
    return nested
  }
  return { value: [] }
}

function buildODataQuery(params: Required<AssetListParams>): string {

  const parts: string[] = [
    `$orderby=${params.orderby.replace(/ /g, '%20')}`,
  ]

  const trimmed = params.searchText.trim()
  if (trimmed) {
    parts.push(`searchText=${encodeURIComponent(trimmed)}`)
  }

  return `?${parts.join('&')}`
}

export async function fetchAssets(
  params: AssetListParams = {},
): Promise<AssetListResponse | null> {
  const {
    orderby = 'serialNumber asc,id asc, productCategoryName asc',
    searchText = '',
  } = params

  try {
    const url = `${API_BASE_URL}${buildODataQuery({ orderby, searchText })}`
    const raw = await get<AssetListEnvelope>(url)

    return normalizeAssetResponse(raw)
  } catch (error) {
    const fallbackMessage = COP_COMMON_ERROR_MESSAGES['api-error'].message.replace(
      '{{action}}',
      COP_COMMON_ERROR_MESSAGES['api-error'].action['assets-search-loading'],
    )
    const message = error instanceof Error && error.message ? error.message : fallbackMessage
    ToastService.error(message)
    return null
  }
}

